export const APPLY_ANCHOR = '#apply_now';
export const UE_LOGO_SRC = '/assets/uber-eats-icon.svg';

export const FlinkMark = ({ className }: { className?: string }) => (
  <img className={className} src="/assets/flink-mark.svg" alt="Flink" />
);

export const IconArrow = () => (
  <svg className="ico ico-sm" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const IconPlus = () => (
  <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const ImagePlaceholder = ({ label }: { label: string }) => (
  <div className="img-placeholder" role="img" aria-label={label}>
    <svg
      width="36"
      height="36"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      aria-hidden="true"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <path d="M21 15l-5-5L5 21" />
    </svg>
    <span>{label}</span>
  </div>
);
